const customerTypes = {
  is_costco: 'COSTCO WHOLESALE CORPORATION',

};

module.exports = {
  customerTypes,
};
